export const createSubscriptionCheckoutSession = async ({
  userUid,
  priceId,
  successUrl,
  cancelUrl,
  trialPeriodDays,
  couponName,
}: {
  userUid?: string;
  priceId: string;
  successUrl: string;
  cancelUrl: string;
  trialPeriodDays?: number | null;
  couponName?: string | null;
}) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_HOST}/api/payments/checkout-session-subscription`,
      {
        method: 'POST',
        body: JSON.stringify({
          userUid,
          priceId,
          successUrl,
          cancelUrl,
          trialPeriodDays,
          couponName,
        }),
      },
    );
    const url = await response.json();

    if (url) {
      // Redirect to the Stripe Checkout page
      if (typeof window !== 'undefined') {
        window.location.href = url;
      }
    } else {
      console.error('No URL received from the server.');
    }
  } catch (error) {
    console.error('Error creating checkout session:', error);
  }
};
